import axios from 'axios';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';

export const PLACES_MIN_QUERY_LENGTH = 3;

export type PlaceSuggestion = {
  value: string;
  label: string;
};

export const searchPlaces = async (
  query: string,
  signal?: AbortSignal,
): Promise<PlaceSuggestion[]> => {
  const input = query.trim();
  if (!GOOGLE_MAPS_API_KEY || input.length < PLACES_MIN_QUERY_LENGTH) return [];

  try {
    const { data } = await axios.post(
      'https://places.googleapis.com/v1/places:autocomplete',
      { input },
      {
        signal,
        headers: {
          'Content-Type': 'application/json',
          'X-Goog-Api-Key': GOOGLE_MAPS_API_KEY,
          'X-Goog-FieldMask': 'suggestions.placePrediction.text',
        },
      },
    );

    const seen = new Set<string>();

    return (data?.suggestions ?? [])
      .map(
        (suggestion: { placePrediction?: { text?: { text?: string } } }) =>
          suggestion?.placePrediction?.text?.text,
      )
      .filter((text: unknown): text is string => typeof text === 'string' && text.length > 0)
      .filter((text: string) => {
        if (seen.has(text)) return false;
        seen.add(text);
        return true;
      })
      .map((text: string) => ({ value: text, label: text }));
  } catch {
    return [];
  }
};
